import React, { Suspense, lazy } from 'react';
import { canUseDOM } from '../../utils';
export const DYNAMIC_POP_UP_CLOSE_EXPIRED = "dynamic-pop-up-close-expired";
const DynamicPopUpLazyLoadedContent = /*#__PURE__*/lazy(() => import("./DynamicPopUpLazyLoadedContent"));
const SuspenseWrapper = props => {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, /*#__PURE__*/React.createElement(DynamicPopUpLazyLoadedContent, props));
};
const DynamicPopup = props => {
  if (canUseDOM && Number(localStorage.getItem(DYNAMIC_POP_UP_CLOSE_EXPIRED)) < Date.now()) {
    return /*#__PURE__*/React.createElement(SuspenseWrapper, props);
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
};
export default DynamicPopup;